const Faye = require('faye');
const socketUrl = process.env.REACT_APP_SOCKET_URL;
const client = new Faye.Client(socketUrl);

class SocketService  {
  setHeader(authToken, socketInfo) {
    if(socketInfo){
      let chanelId = socketInfo.chanelId;

      client.addExtension({
        outgoing: function (message, callback) {
          if (message.channel !== '/meta/subscribe' && message.channel !== '/service/teleconsult_on_demand/status' && message.channel !== '/meta/disconnect') {
            return callback(message);
          }
  
          if (message.channel === '/service/teleconsult_on_demand/status'){

            message.data = message.data || {};
            message.data['Authorization'] = authToken
          }else{
            message.ext = message.ext || {};
            message.ext['Authorization'] = authToken
            if (chanelId) {
              if (socketInfo.isClinic) {
                message.ext['clinicId'] = chanelId;
              } else {
                message.ext['doctorId'] = chanelId;
              }
  
            }
          }
          callback(message);
        },
        incoming: function (message, callback) {
          if (message.channel === '/meta/subscribe' && message.subscription.startsWith('/teleconsult_on_demand/doctor/')){

            client.publish('/service/teleconsult_on_demand/status');
          }
          callback(message);
        }
      });
    }else{
      client.addExtension({
        outgoing: function (message, callback) {
          if (message.channel !== '/meta/subscribe' && message.channel !== '/service/teleconsult_on_demand/status' && message.channel !== '/meta/disconnect') {
            return callback(message);
          }
          if (message.channel === '/service/teleconsult_on_demand/status'){

            message.data = message.data || {};
            message.data['Authorization'] = authToken
          }else{
            message.ext = message.ext || {};
            message.ext['Authorization'] = authToken
          }
          callback(message);
        },
        incoming: function (message, callback) {
          if (message.channel === '/meta/subscribe' && message.subscription.startsWith('/teleconsult_on_demand/doctor/')){
            client.publish('/service/teleconsult_on_demand/status');
          }
          callback(message);
        }
      });
    }
  }

  getLatestTeleconsultOnDemandStatus() {
    client.publish('/service/teleconsult_on_demand/status', {}).then(() => {
    })
    .catch(error => {
      console.error('Error publishing message:', error);
    });
  }

  subscribe(channel, socketInfo, callback) {
    if (socketInfo?.chanelId) {
      client.subscribe(channel + socketInfo.chanelId, callback);
    }else{
      client.subscribe(channel, callback);
    }
  }

  unsubscribe(channel, socketInfo){
    if (socketInfo?.chanelId) {
      client.unsubscribe(channel + socketInfo.chanelId);
    }else{
      client.unsubscribe(channel);
    }
  }
}

export default new SocketService();